import React, { useContext } from 'react';
import { ThemeContext } from '../../contexts/ThemeContext';
import Fade from 'react-reveal/Fade';
import './Experience.css';
import expImgWhite from '../../assets/svg/experience/expImgWhite.svg'
import expImgBlack from '../../assets/svg/experience/expImgBlack.svg'
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

function ExperienceCard({ id, company, jobtitle, startYear, endYear, description, image,fullDescription }) {
    const { theme } = useContext(ThemeContext);
	

    return (
       <Fade bottom>
    <div key={id} className="experience-card" style={{ backgroundColor: theme.primary30, padding: '1rem', borderRadius: '10px', display: 'flex', alignItems: 'flex-start', flexDirection: 'row', width: '100%' }}>
        <div className="expcard-img" style={{ backgroundColor: theme.primary, width: '60px', height: '60px', borderRadius: '50%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginRight: '1rem' }}>
        <Popup
    trigger={<button className="button">Explorer </button>}
   
  
	 closeOnDocumentClick
  >
    {close => (
      <div className="modal">
        <button className="close" onClick={close}>
          &times;
        </button>
        
        <div className="content">
          
			  {fullDescription}
        </div>
        
      </div>
    )}
  </Popup>
        </div>
        <div className="experience-details" >

            <h4 style={{ color: theme.tertiary, marginBottom: '0.25rem' }}>{jobtitle}</h4>
            <h5 style={{ color: theme.tertiary80, marginBottom: '0.5rem' }}>{company}</h5>

        </div>
		 
    </div>
</Fade>

    );
}

export default ExperienceCard;
